import React, { useMemo, useRef } from "react";

import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useCustomerPortalJobContext } from "Context/CustomerPortalJobContext";

import { SummaryJobDetailsSection, SummaryLivePositionSection } from "./sections";
import { FlexContainerLeftSection, FlexContainerRightSection, MainContentDetails } from "./styled";

const DetailsPanel = () => {
  const { customerShipmentsWithTracking, isLoading, isCustomerShipmentsLoading } =
    useCustomerPortalJobContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));

  const showLivePositionSection = useMemo(() => {
    return isLoading || isCustomerShipmentsLoading || !!customerShipmentsWithTracking?.length;
  }, [isLoading, isCustomerShipmentsLoading, customerShipmentsWithTracking]);

  const leftSideRef = useRef<HTMLDivElement>(null);
  const heightSide = (leftSideRef?.current?.offsetHeight || 590) - 10;

  return (
    <MainContentDetails>
      <FlexContainerLeftSection ref={leftSideRef}>
        <SummaryJobDetailsSection />
      </FlexContainerLeftSection>

      <FlexContainerRightSection
        in={showLivePositionSection}
        orientation={matches ? "horizontal" : "vertical"}
        unmountOnExit
        height={heightSide}
      >
        <SummaryLivePositionSection minHeight={heightSide - 128} />
      </FlexContainerRightSection>
    </MainContentDetails>
  );
};

export { DetailsPanel };
